import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from './BufferedSourceJsonReader.mjs';
import { MapJsonReader2b7ri7r44421y as MapJsonReader } from './MapJsonReader.mjs';
import {
  toIntExactOrNull6ky18km1ou13 as toIntExactOrNull,
  toIntExactOrNull2t2wdfvexswy6 as toIntExactOrNull_0,
  toLongExactOrNull3c5zyitei28os as toLongExactOrNull,
} from './internal/Utils.mjs';
import { Token_LONG_getInstance1q4dpv6tjhcl0 as Token_LONG_getInstance } from './JsonReader.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readAny(_this__u8e3s4) {
  var token = _this__u8e3s4.x3x();
  var tmp;
  switch (token.w1_1) {
    case 9:
      tmp = _this__u8e3s4.s49();
      break;
    case 8:
      tmp = _this__u8e3s4.jo();
      break;
    case 7:
    case 6:
      tmp = guessNumber(_this__u8e3s4);
      break;
    case 5:
      tmp = _this__u8e3s4.t3y();
      break;
    case 2:
      _this__u8e3s4.g3y();
      // Inline function 'kotlin.collections.mutableMapOf' call

      var result = LinkedHashMap().ec();
      while (_this__u8e3s4.q1()) {
        result.a5(_this__u8e3s4.i3y(), readAny(_this__u8e3s4));
      }

      _this__u8e3s4.h3y();
      tmp = result;
      break;
    case 0:
      _this__u8e3s4.o3y();
      // Inline function 'kotlin.collections.mutableListOf' call

      var result_0 = ArrayList().p2();
      while (_this__u8e3s4.q1()) {
        result_0.j2(readAny(_this__u8e3s4));
      }

      _this__u8e3s4.p3y();
      tmp = result_0;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'unknown token ' + token.toString();
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
function guessNumber(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof MapJsonReader()) {
    tmp = _this__u8e3s4.d4d();
  } else {
    if (_this__u8e3s4 instanceof BufferedSourceJsonReader()) {
      tmp = guessNumberNoThrow(_this__u8e3s4);
    } else {
      tmp = guessNumberOrThrow(_this__u8e3s4);
    }
  }
  return tmp;
}
function guessNumberNoThrow(_this__u8e3s4) {
  if (_this__u8e3s4.x3x().equals(Token_LONG_getInstance())) {
    var asLong = _this__u8e3s4.go();
    var tmp0_elvis_lhs = toIntExactOrNull(asLong);
    return tmp0_elvis_lhs == null ? asLong : tmp0_elvis_lhs;
  }
  var tmp;
  try {
    tmp = _this__u8e3s4.y3y();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
      return _this__u8e3s4.p4c();
    } else {
      throw $p;
    }
  }
  var asDouble = tmp;
  var tmp1_elvis_lhs = toIntExactOrNull_0(asDouble);
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toLongExactOrNull(asDouble) : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? asDouble : tmp2_elvis_lhs;
}
function guessNumberOrThrow(_this__u8e3s4) {
  try {
    return _this__u8e3s4.pk();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.go();
  } catch ($p_0) {
    if ($p_0 instanceof Exception()) {
      var _unused_var__etf5q3_0 = $p_0;
    } else {
      throw $p_0;
    }
  }
  try {
    return _this__u8e3s4.y3y();
  } catch ($p_1) {
    if ($p_1 instanceof Exception()) {
      var _unused_var__etf5q3_1 = $p_1;
    } else {
      throw $p_1;
    }
  }
  return _this__u8e3s4.p4c();
}
function jsonReader(_this__u8e3s4) {
  return new (BufferedSourceJsonReader())(_this__u8e3s4);
}
function jsonReader_0(_this__u8e3s4) {
  return new (MapJsonReader())(_this__u8e3s4);
}
//region block: exports
export {
  jsonReader as jsonReaderkr2c3w0efm9b,
  jsonReader_0 as jsonReader2agwreccj3lmk,
  readAny as readAny17j2jqaxubdko,
};
//endregion

//# sourceMappingURL=JsonReaders.mjs.map
